export default class promoCodes {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                accountId: '@'
            },
            template: require('../../../../views/setting/partials/promo-codes.html'),
            controller: PromoCodesCtrl,
            controllerAs: 'promoCodesCtrl'
        }
    }
};

class PromoCodesCtrl {
    constructor($scope, $filter, $element, $location, Setting, Events, SweetAlert) {
        this._scope = $scope;
        this._element = $element;
        this._filter = $filter;
        this._location = $location;
        this._translate = $filter('translate');
        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.groups = [];
        this.settingsRepo = Setting;
        this.failedGroupFetch = false;
        this.addGroupField = false;
        this.showGroups = false;
        this.initialName = 'NewGroup';
        this.form = {
            show: false,
            type: this.initialName
        };

        this.getAllGroups();
    }

    getAllGroups() {
        this.settingsRepo.getPromoCodesGroups()
            .then(groups => {
                this.groups = groups;
                this.restForm();
            })
            .catch(({data}) => {
                this.failedGroupFetch = true;
                this.eventHandler.flashEvent('error', data.message || this._translate('PROMO_CODES:ERROR:FETCH'));
            });
    }

    addGroup() {
        this.showFrom();
        setTimeout(() => this._element.find('#form-activator').click());
    }

    saveNewGroup() {
        if (this.form.type.includes(' ')) {
            this.alerter.swal({
                title: this._translate('PROMO_CODES:FLASH:SAVE:HEAD'),
                text: this._translate('PROMO_CODES:FLASH:SAVE:BODY'),
                showCancelButton: false,
                confirmButtonText: this._translate('GLOBAL:OK'),
                type: 'warning'
            }, () => {
                this.hideForm();
            });
            return;
        }
        this.settingsRepo.createPromoCodesGroup(
            this._filter('getNumberedName')(this.getGroupsNames(), this.form.type)
        ).then(() => {
            this.getAllGroups();
        }).catch(({data}) => {
            this.eventHandler.flashEvent('error', data.message || this._translate('PROMO_CODES:ERROR:CREATE'));
        });
        this.hideForm();
    }

    showFrom() {
        this.form.show = true;
    }

    hideForm() {
        this.form.show = false;
        this.restForm();
    }

    uploadGroupCodes(group, file) {
        group.loading = true;
        this.settingsRepo.uploadPromoCodes(file, group.type)
            .then(() => {
                this.getAllGroups();
                group.loading = false;
            })
            .catch(({data}) => {
                this.eventHandler.flashEvent('error', data.message || this._translate('PROMO_CODES:ERROR:UPLOAD'));
                group.loading = false;
            });
    }

    toggleGroups() {
        this.showGroups = !this.showGroups;
    }

    restForm() {
        this.form.type = this._filter('getNumberedName')(this.getGroupsNames(), this.initialName);
    }

    clearPromocodes(group) {
        this.alerter.swal({
            title: this._translate('PROMO_CODES:FLASH:CLEAR:HEAD'),
            text: this._translate('PROMO_CODES:FLASH:CLEAR:BODY', {groupType: group.type}),
            showCancelButton: true,
            confirmButtonText: this._translate('GLOBAL:YES'),
            cancelButtonText: this._translate('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.settingsRepo.clearPromocodes(group.type_id)
                    .then(() => this.getAllGroups())
                    .catch(({data}) => {
                        this.eventHandler.flashEvent('error', data.message || this._translate('translate')('PROMO_CODES:ERROR:CLEAR'));
                    });
            }
        });
    }

    deleteGroup(group) {
        this.alerter.swal({
            title: this._translate('GLOBAL:FLASH:DELETE'),
            text: this._translate('PROMO_CODES:FLASH:DELETE:BODY', {groupType: group.type}),
            showCancelButton: true,
            confirmButtonText: this._translate('GLOBAL:YES'),
            cancelButtonText: this._translate('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.settingsRepo.deletePromocodesGroup(group.type_id)
                    .then(() => this.getAllGroups())
                    .catch(({data}) => {
                        this.eventHandler.flashEvent('error', data.message || this._translate('translate')('PROMO_CODES:ERROR:DELETE'));
                    });
            }
        });
    }

    getGroupUrl(group) {
        return `
            [RemoteContent:nocache:${this._location.protocol()}://${this._location.host()}/promo-codes/${this._scope.accountId}/${group.type}]
        `;
    }

    getGroupsNames() {
        return this.groups.map(group => group.type);
    }
}
